import { List, Map, Set } from 'immutable';

import { ActionTypes } from './actions';

export interface State {
	collapsePaths: Map<List<string>, Set<string>>;
}

interface Action {
	type: 'TreeBrowser.toggleItem';
	path: List<string>;
	key: string;
}

function createState(): State {
	return {
		collapsePaths: Map(),
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.toggleItem:
			return {
				...state,
				collapsePaths: state.collapsePaths.update(action.path, Set(), (keys) => {
					return keys.has(action.key) ? keys.delete(action.key) : keys.add(action.key);
				}),
			};

		default:
			return state;
	}
}
